import axios from "axios";
// 创建axios实例
const request = axios.create({
  timeout: 30000, // 请求超时时间(毫秒)
  headers: {
    "content-type": "application/json;charset=UTF-8", //转换为key=value的格式必须增加content-type
  },
  withCredentials: true, // 异步请求携带cookie
});

// request 拦截
request.interceptors.request.use(
  (config) => {
    // 如果你要去localStor获取token
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = token;
    }

    const dataType = config.data?.dataType;
    if (dataType) {
      config.responseType = "blob";
    }

    return config;
  },
  (error) => {
    // 对请求错误做些什么
    Promise.reject(error);
  }
);

// response 拦截器
request.interceptors.response.use(
  (response) => {
    // 对响应数据做点什么
    //  存储token
    if (response.headers.authorization) {
      if (localStorage.getItem("roleInfo")) {
        localStorage.setItem("token", response.headers.authorization);
      }
    }
    const codeArr = [300, 1109]; // 300 登录失效 1109 token错误

    if (codeArr.includes(response.data.code)) {
      localStorage.removeItem("token");
      localStorage.removeItem("roleInfo");
      location.href = "#/login";
    }
    return response.data;
  },
  (error) => {
    // 对响应错误做点什么
    return Promise.reject(error);
  }
);
export default request;
